var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-block text-teal-800 text-xs px-2 rounded-full uppercase font-semibold tracking-wide",class:_vm.badgeColor},[_vm._v(" "+_vm._s(_vm.data.is_active ? "Active" : "Inactive")+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }